import { put, takeEvery, call } from "redux-saga/effects";
import addShiftDefinition from "sc/backend/oncall/partners/shifts-definitions/add";
import {
  REQUEST_CREATE_SHIFT_DEFINITION,
  shiftDefinitionCreated,
  shiftDefinitionError,
} from "../../actions/shifts-definitions";

const requestCreate = function*(action) {
  try {
    const result = yield call(
      addShiftDefinition,
      action.payload.regionId,
      action.payload.engineerId,
      action.payload.startDate,
    );
    yield put(
      shiftDefinitionCreated({
        id: parseInt(result.id, 10),
        regionId: action.payload.regionId,
        engineerId: action.payload.engineerId,
        startDate: result.startDate,
        startTime: result.startTime,
        days: result.days,
        endTime: result.endTime,
        priority: result.priority,
      }),
    );
  } catch (error) {
    yield put(shiftDefinitionError(error.message));
  }
};

export default function*() {
  //noinspection JSCheckFunctionSignatures
  yield takeEvery(REQUEST_CREATE_SHIFT_DEFINITION, requestCreate);
}



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/sagas/shifts-definitions/request-create.js